<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <h1>{{ 'INTL_DOCUMENTS_UPLOAD' | translate }}</h1>
  <button mat-icon-button type="button" aria-label="Close upload dialog" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <mat-form-field class="dropzone-form-field" appearance="fill">
    <mat-label>{{ 'INTL_DROPZONE_PLACEHOLDER' | translate }}</mat-label>
    <ngx-mat-dropzone class="dropzone-area" [placeholder]="'INTL_DROPZONE_PLACEHOLDER' | translate">
      <input type="file" fileInput [formControl]="filesControl" multiple />
    </ngx-mat-dropzone>
    <mat-error *ngIf="filesControl.hasError('fileDuplicates')" class="form-error">
      {{ 'INTL_FILE_EXISTS' | translate }}
    </mat-error>
  </mat-form-field>

  <ng-container *ngIf="files | async as _files">
    <div *ngIf="asFileItemArray(_files)?.length" class="bulk-actions">
    <button mat-button [disabled]="isUploading || (hasFilesToUpload | async) === false" (click)="clickOnUpload()">
      <mat-icon color="secondary">upload</mat-icon>
      {{ 'INTL_UPLOAD' | translate }}
    </button>
    <button mat-button [disabled]="isUploading" (click)="close()">
      <mat-icon color="secondary">block</mat-icon>
      {{ 'INTL_CANCEL' | translate }}
    </button>
    <button mat-button [disabled]="isUploading" (click)="removeAll()">
      <mat-icon color="secondary">delete</mat-icon>
      {{ 'INTL_DELETE' | translate }}
    </button>
  </div>

  <table *ngIf="asFileItemArray(_files)?.length" mat-table [dataSource]="tableDataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'INTL_NAME' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <div class="file-name-container">
          <div class="file-name">
            <fa-icon
              [icon]="getIcon(element?.type)"
              class="icon small"
              [ngClass]="getIconColor(element?.type)"
            ></fa-icon>
            <strong>{{ element.name }}</strong>
          </div>
          <div *ngIf="element.error" class="form-error">{{ element.error }}</div>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef>{{ 'INTL_TOTAL_SIZE' | translate }}</td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef>{{ 'INTL_SIZE' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.size | fileSize }}
      </td>
      <td mat-footer-cell *matFooterCellDef>{{ totalSize | async | fileSize }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let index = index; let element" style="text-align: right">
        <button
          *ngIf="!element.isUploading && !element.uploaded && !isUploading"
          mat-icon-button
          (click)="remove(index)"
        >
          <mat-icon color="secondary">delete</mat-icon>
        </button>
        <div *ngIf="element.isUploading" class="icon-container">
          <mat-spinner class="file-spinner" diameter="21"></mat-spinner>
        </div>
        <div *ngIf="element.uploaded" class="icon-container">
          <mat-icon color="primary">check_circle</mat-icon>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="3">
        {{ 'INTL_EMPTY_FILES_LIST' | translate }}
      </td>
    </tr>
  </table>
    </ng-container>
  </div>

<div *ngIf="showSuccessMessage$ | async" class="success-message">
  <mat-icon color="primary">check_circle</mat-icon>
  <span>{{ 'INTL_ALL_DOCUMENTS_UPLOADED_SUCCESSFULLY' | translate }}</span>
</div>

<div class="files-validation">
  <mat-error *ngIf="filesControl.hasError('invalidFileExtensions')" class="form-error">
    {{ 'INTL_INVALID_FILE_EXTENSION' | translate : { files: filesControl.getError('invalidFileExtensions') } }}
  </mat-error>
</div>
